export default function SubscribeBand() {
  return (
    <section className="px-4 pb-14 md:px-10 md:pb-20">
      <div className="overflow-hidden rounded-lg bg-primary-500 px-6 py-10 md:px-12 md:py-14">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-xl">
            <div className="font-label text-[11px] uppercase tracking-[0.3em] text-background-100">
              Weekly Digest
            </div>
            <h2 className="mt-3 font-heading text-2xl font-black leading-snug text-background-50 md:text-4xl">
              每周一封，只挑值得看的更新
            </h2>
            <p className="mt-4 text-sm leading-loose text-primary-100">
              把一周里的今日热点、话题新进展与编辑精选收成一封信。不需要每天盯着，也不会错过真正有分量的那几条。
            </p>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#topics"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100"
            >
              <i className="ri-mail-send-line" />
              订阅周刊
            </a>
            <a
              href="#ranking"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-200 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              查看热度榜
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}